import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6aa05c56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref, computed } from "vue";
import { ProductItem } from "@/models/product.model";
import OnlineForm from "@/components/popups/attachments/attach-file/OnlineForm.vue";
import UploadForm from "@/components/popups/attachments/attach-file/UploadForm.vue";
import FileLibraryForm from "@/components/popups/attachments/attach-file/FileLibraryForm.vue";
import { ContentStructureSection } from "@/models/content-structure.model";
import { useUIFilesStore } from "@/stores/ui-files.store";
import Popup from "@/components/Popup.vue";

const UPLOAD_FILE = 0;
const ONLINE_ATTACHMENT = 1;
const EXISTING_ATTACHMENT = 2;

export default /*#__PURE__*/_defineComponent({
  __name: 'AttachFile',
  setup(__props) {

const uiFilesStore = useUIFilesStore();

const activeTab = ref<number>(UPLOAD_FILE);

const target = computed<ContentStructureSection | ProductItem | null>(() => {
  if (uiFilesStore.sectionToAttachFile) {
    return uiFilesStore.sectionToAttachFile;
  }
  if (uiFilesStore.productToAttachFile) {
    return uiFilesStore.productToAttachFile;
  }
  return null;
});
const name = computed<string>(() => {
  return target.value ? target.value.name : "";
});

return (_ctx: any,_cache: any) => {
  const _component_b_tab_item = _resolveComponent("b-tab-item")!
  const _component_b_tabs = _resolveComponent("b-tabs")!

  return (_openBlock(), _createBlock(Popup, {
    "data-testing-modal-card": 'attach-file-card',
    onClosePopup: _unref(uiFilesStore).closeAttachFileModal
  }, {
    header: _withCtx(() => [
      _createElementVNode("h3", null, [
        (_unref(uiFilesStore).shouldBeSetAsMediaContent)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Set Media Content for: "))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, "Attach content to ")),
        _createElementVNode("i", null, _toDisplayString(name.value), 1)
      ])
    ]),
    body: _withCtx(() => [
      _createVNode(_component_b_tabs, {
        "data-testing": "tabs",
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
        "destroy-on-hide": true,
        animated: false,
        position: 'is-centered',
        expanded: true,
        class: "attach-file-tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_tab_item, { label: "Upload" }, {
            default: _withCtx(() => [
              _createVNode(UploadForm)
            ]),
            _: 1
          }),
          _createVNode(_component_b_tab_item, { label: "Link to online content" }, {
            default: _withCtx(() => [
              _createVNode(OnlineForm)
            ]),
            _: 1
          }),
          _createVNode(_component_b_tab_item, { label: "Select from Library" }, {
            default: _withCtx(() => [
              _createVNode(FileLibraryForm)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["onClosePopup"]))
}
}

})